// removed by extract-text-webpack-plugin
module.exports = {"deptText":"KopJl-Qp2GXVMFIGli_1o","dropDownSection":"_fBRLNksT0a2GFjI7SPna","LoginSplash":"_1Pm5hmI52rvYYEjBcy4UJ4","loginSplash":"_1Pm5hmI52rvYYEjBcy4UJ4","LoginSplashForm":"_1eh66JgT-z1dMPlew75p3I","loginSplashForm":"_1eh66JgT-z1dMPlew75p3I","LoginSplashLogo":"NIBtPebvC6JX5ufN8Y-U1","loginSplashLogo":"NIBtPebvC6JX5ufN8Y-U1","LoginSplashButton":"_3JX--1DRYEDLHDObxVsZgy","loginSplashButton":"_3JX--1DRYEDLHDObxVsZgy","headerText":"mzGnqUj-ijdoAvJ134nz4","left":"hJm1xI5RcLja3VLNrmV8z"};


//////////////////
// WEBPACK FOOTER
// ./components/home.css
// module id = 1614
// module chunks = 0